import { Box, ColorOptions, convertHexToRGBA, Icon, IconOptions, Loader, ModBox, Spacer, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/core'
import { useEffect, useState } from 'react'
import { Alert, Platform, ScrollView } from 'react-native'
import { HeaderLeft } from '../../comps/MobileCustomHeader/HeaderLeft'
import { SvgImage } from '../../comps/SvgImage'
import { useLazyApiData, useStores } from '../../data/store'
import { Routes } from '../../nav/routes'
import { Colors, getErrorState, isOsMobile, testProps } from '../../util/util'
import { DetailsLayout } from './DetailsLayout'
import { Header } from './Header'
import styles from './styles'

interface transactionIdInterface {
  route?: any
  txnId: string
}

const TxnDetails = ({ route, txnId }: transactionIdInterface) => {
  const { transactionId, path, tab, transactionDate, refundAmount } = route?.params ?? { transactionId: txnId }
  const navigation = useNavigation()

  const [isRefundModalVisible, setRefundModalVisibility] = useState(false)

  const { getTransactionDetails, mid, newTransactionDetails, getOriginId } = useStores((store) => ({
    getTransactionDetails: store.transactions.getTransactionDetailsV3,
    mid: store.user.selectedMid,
    newTransactionDetails: store.transactions.newTransactionDetails,
    getOriginId: store.transactions.getOriginalId,
  }))
  const [fetchTxnDetails, txnDetailsHandler] = useLazyApiData(getTransactionDetails)

  const errorState = getErrorState([txnDetailsHandler])
  useEffect(() => {
    if (transactionId !== '' && transactionId !== undefined) {
      fetchTxnDetails(mid, transactionId, transactionDate, path, tab, true)
    }
  }, [fetchTxnDetails, mid, path, transactionId, tab, transactionDate])

  // let status = values[1]?.status?.toLowerCase() ?? ''
  const txnDetails = newTransactionDetails(path, transactionId, tab)
  const txnStatus = txnDetails?.details?.status

  const headerLeft = () => {
    return (
      <Box backgroundColor={'TRANSPARENT'} flexDirection="row" justifyContent="center" alignItems={'center'} h={64}>
        <ModBox
          paddingLeft={25}
          paddingRight={10}
          top={Platform.OS === 'ios' ? -30 : 0}
          show={navigation?.canGoBack()}
          underlayColor={'TRANSPARENT'}
          testID="back-arrow"
          onPress={() => navigation?.goBack()}>
          <SvgImage imageName="HeaderArrowLeft" />
        </ModBox>
      </Box>
    )
  }

  useEffect(() => {
    navigation?.setOptions({
      title: '',
      headerTintColor: '#fff',
      headerBackVisible: true,
      headerLeft: Platform.OS === 'ios' ? headerLeft : () => <HeaderLeft />,
      headerStyle: {
        backgroundColor: Colors.SECONDARY,
        top: Platform.OS === 'ios' ? -30 : 0,
      },
    })
  }, [])

  const isRefundPossible = txnStatus === 'SUCCESS'
  const buttonWithIcon = (label: string, id: IconOptions, func: () => void, isRefund: boolean) => {
    return (
      <Box
        {...styles.actionWrapper(label === 'Refund')}
        {...testProps(label)}
        disabled={!isRefund || !isRefundPossible}
        borderWidth={1}
        borderColor={
          !isRefund || !isRefundPossible ? (convertHexToRGBA(Colors.PRIMARY, 50) as ColorOptions) : 'PRIMARY'
        }
        borderRadius={32}
        onPress={() => func()}>
        <Icon
          id={id}
          color={!isRefund || !isRefundPossible ? (convertHexToRGBA(Colors.PRIMARY, 50) as ColorOptions) : 'PRIMARY'}
          size={22}
        />
        <Spacer size={8} direction="horizontal" />
        <Text
          {...styles.actionText}
          color={!isRefund || !isRefundPossible ? (convertHexToRGBA(Colors.PRIMARY, 50) as ColorOptions) : 'PRIMARY'}>
          {label}
        </Text>
      </Box>
    )
  }

  const onRefundPress = () => {
    setRefundModalVisibility(true)
  }
  const closeModal = () => {
    setRefundModalVisibility(false)
  }

  const trxnId = getOriginId(transactionId)

  const detailsObj = {
    paymentMethod: txnDetails?.details?.paymentMode,
  }
  let amount = txnDetails?.details?.amount ?? 0

  const navigateToChatbot = () => {
    if (Platform.OS === 'android') {
      navigation?.navigate(Routes.CHATBOT as never, { isAfterLogin: true, transactionID: transactionId } as never)
    } else {
      Alert.alert('Need help?', 'The iOS platform is not supported at this time.')
    }
  }

  const handleRetry = () => {
    if (transactionId !== '' && transactionId !== undefined) {
      fetchTxnDetails(mid, transactionId, transactionDate, path, tab)
    }
  }
  const isApiLoading = txnDetailsHandler?.state === 'pending'

  const [isLoading, setIsLoading] = useState(true)
  const showLoader = isLoading || isApiLoading
  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false)
    }, 1000)
  }, [])

  const detailsTransactionId = txnDetails?.id

  useEffect(() => {
    if (!showLoader && detailsTransactionId === 'NA') {
      navigation.goBack()
    }
  }, [detailsTransactionId, showLoader, navigation])

  return (
    <ModBox
      backgroundColor={'SECONDARY'}
      flex={1}
      align={errorState || showLoader ? 'center' : undefined}
      justify={errorState || showLoader ? 'center' : 'flex-start'}>
      <ModBox show={errorState} onPress={handleRetry} testID="retry">
        <SvgImage imageName={'RefreshIcon'} width={24} height={24} color={Colors.PRIMARY} />
      </ModBox>
      <ModBox show={showLoader}>
        <Loader color="PRIMARY" />
      </ModBox>
      <ModBox
        borderTopLeftRadius={24}
        bg={'WHITE'}
        borderTopRightRadius={24}
        p={24}
        f={1}
        show={!showLoader && txnDetailsHandler?.state === 'fulfilled'}>
        <ScrollView>
          <Header
            amount={tab === 'refunded' ? refundAmount.substring(1) : amount}
            txnStatus={txnStatus}
            name={txnDetails?.customerDetails?.name}
            timestamp={txnDetails?.details?.timestamp}
            tab={tab}
          />
          <Box borderWidth={1} borderColor={'DISABLED_GREY'} borderRadius={8} p={16}>
            <DetailsLayout
              txnId={trxnId}
              isRefundModalVisible={isRefundModalVisible}
              handleClose={closeModal}
              path={path}
              tab={tab}
            />
          </Box>
          {Platform.OS === 'android' && (
            <ModBox
              show={isOsMobile()}
              borderWidth={1}
              borderColor={'DISABLED_GREY'}
              borderRadius={8}
              ph={16}
              pv={12}
              overflow={'auto'}
              align={'center'}
              justify={'space-between'}
              marginVertical={24}
              testID="navigateToChatbot"
              onPress={navigateToChatbot}
              underlayColor={'TRANSPARENT'}
              flexDirection="row">
              <Text
                title={'Need help?'}
                fontFamily={'JioType-Bold'}
                fontSize={16}
                lineHeight={24}
                letterSpacing={-0.08}
                color={Colors.BLACK_14 as ColorOptions}
              />
              <Icon id={'ARROW_RIGHT'} color={'PRIMARY'} size={16} />
            </ModBox>
          )}

          <ModBox {...styles.actionTab} show={false}>
            {buttonWithIcon('Refund', 'REFUNDS', onRefundPress, isRefundPossible)}
            {/* {buttonWithIcon('Share Receipt', 'SHARE', onShare, true)} */}
          </ModBox>
        </ScrollView>
      </ModBox>
    </ModBox>
  )
}

export default TxnDetails
